import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

const GENERATE_IMPORT_FILE = '/contract-lot/generate-import-file';
const GET_CONTRACT_LOT_BY_ID = '/contract-lot/get-by-id/';
const GET_ALL_PROCESSING = '/contract-lot/get-all-processing';
const CREATE_CONTRACT_LOT = '/contract-lot/create';
const CREATE_CONTRACT_LOT_DIGITAL = '/contract-lot/digital/create';
const GET_RESULT_FILE = '/contract-lot/get-result-file/'
const GET_PROPERTIES_CONTRACT_LOT = '/contract-lot/get-properties-contract-lot/'

@Injectable({
    providedIn: 'root'
})
export class ContractLotService {

    public processingStart: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private apiService: ApiService) { }

    generateImportFile(body: { documentTypeEnterpriseId: string,  maxNumberOfPartner: number, type?: string}) {
        return this.apiService.getFilePostMethod(GENERATE_IMPORT_FILE, body)
            .pipe(map(res => {
                return res;
            }));
    }

    getContractLotById(id) {
        return this.apiService.get(GET_CONTRACT_LOT_BY_ID + id)
            .pipe(map(res => {
                return res
            }));
    }

    generateImportFileDigital(body: { serviceTypeId: number,  maxNumberOfPartner: number, uploadedFiles: any[]}) {
        return this.apiService.getFilePostMethod('/contract-lot/generate-import-file-digital', body)
            .pipe(map(res => {
                return res;
            }));
    }

    getPropertiesContractLotById(id) {
        return this.apiService.get(GET_PROPERTIES_CONTRACT_LOT + id)
            .pipe(map(res => {
                return res
            }));
    }

    getAllProcessing(param: { page: number, size: number }) {
        return this.apiService.get(`${GET_ALL_PROCESSING}?page=${param.page}&size=${param.size}`)
            .pipe(map(res => {
                return res
            }));
    }

    createContractLot(body) {
        return this.apiService.post(CREATE_CONTRACT_LOT, body)
            .pipe(map(res => {
                return res
            }));
    }

    createContractLotDigital(body) {
        return this.apiService.post(CREATE_CONTRACT_LOT_DIGITAL, body)
            .pipe(map(res => {
                return res
            }));
    }

    getResultFile(id: string) {
        return this.apiService.getFilePostMethod(`${GET_RESULT_FILE}${id}`, null)
            .pipe(map(res => {
                return res;
            }))
    }
}
